type QueryLoadState = {isLoading: boolean; isFetched: boolean};

const isFirstLoad = ({isLoading, isFetched}: QueryLoadState) => isLoading && !isFetched;

export {isFirstLoad};
